import React from 'react'
import EventFormFieldText from './event_form_field_text'
import EventFormFieldEmail from './event_form_field_email'
import EventFormFieldDropdown from './event_form_field_dropdown'
import EventFormFieldDisplay from './event_form_field_display'
import EventFormFieldRadio from './event_form_field_radio'
import EventFormFieldCheckbox from './event_form_field_checkbox'


var EventFormField = React.createClass({
  propTypes: {
    onChange: React.PropTypes.func.isRequired,
    label: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    value: React.PropTypes.any.isRequired,
    field_type: React.PropTypes.string.isRequired,
    response_options: React.PropTypes.array,
    required: React.PropTypes.bool,
    locked: React.PropTypes.bool
  },
  render: function() {
    const { label, name, field_type, required } = this.props;
    const components = {
      'text' : EventFormFieldText,
      'email' : EventFormFieldEmail,
      'dropdown' : EventFormFieldDropdown,
      'display' : EventFormFieldDisplay,
      'radio' : EventFormFieldRadio,
      'checkbox' : EventFormFieldCheckbox
    };
    var Component = components[field_type];
    return(
      <Component {... this.props} />
    );
  }
});

export default EventFormField;


// WEBPACK FOOTER //
// ./src/components/event_form_field.js